import { useEffect, useState } from "react";
import api from "./api";

// Display currencies we show a local guide for. GBP is the base (no secondary line).
export const LOCAL = {
  USD: { short: "US", who: "US", monthly: "US$9.99", yearly: "US$89", gift: "US$89" },
  CAD: { short: "CA", who: "Canadian", monthly: "CA$12.99", yearly: "CA$119", gift: "CA$119" },
};

const US_TZ = /America\/(New_York|Chicago|Denver|Los_Angeles|Phoenix|Anchorage|Detroit|Boise|Indiana|Kentucky|Menominee|Sitka|Juneau|Metlakatla|Nome|Adak|Honolulu)/;
const CA_TZ = /America\/(Toronto|Vancouver|Edmonton|Winnipeg|Halifax|Montreal|Regina|St_Johns|Moncton|Whitehorse|Yellowknife|Iqaluit|Glace_Bay|Blanc-Sablon)/;

function localeCurrency() {
  try {
    const lang = navigator.language || "";
    let region = "";
    try { region = (new Intl.Locale(lang).maximize().region || "").toUpperCase(); }
    catch { region = (lang.split("-")[1] || "").toUpperCase(); }
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || "";
    if (region === "US" || US_TZ.test(tz)) return "USD";
    if (region === "CA" || CA_TZ.test(tz)) return "CAD";
  } catch { /* ignore */ }
  return "GBP";
}

export async function detectCurrency() {
  try {
    const { data } = await api.get("/geo/currency");
    if (data?.currency) return data.currency;
  } catch { /* fall back below */ }
  return localeCurrency();
}

// Returns the detected display currency: "GBP" | "USD" | "CAD" (default GBP until resolved).
export function useCurrency() {
  const [cur, setCur] = useState("GBP");
  useEffect(() => { let ok = true; detectCurrency().then((c) => { if (ok) setCur(c); }); return () => { ok = false; }; }, []);
  return cur;
}
